export const MS_PER_DAY = 86_400_000;

/**
 * Projette une date ISO ('YYYY-MM-DD', telle que la renvoie le parser pg pour
 * les colonnes DATE — cf. OID 1082) sur un axe entier de jours UTC.
 *
 * On passe par Date.UTC plutôt que `new Date(iso)` + arithmétique locale :
 * cette dernière décale d'un jour au passage à l'heure d'été (une journée y
 * fait 23 ou 25 h). Le Gantt et les jalons comparent des jours, jamais des
 * instants.
 */
export function isoToDayIndex(iso: string): number {
  const [y, m, d] = iso.split('-');
  return Date.UTC(Number(y), Number(m) - 1, Number(d)) / MS_PER_DAY;
}

/** Aujourd'hui — jour LOCAL de l'utilisateur, exprimé sur le même axe. */
export function todayDayIndex(): number {
  const n = new Date();
  return Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()) / MS_PER_DAY;
}

/** Retour vers une Date (en UTC) pour la mise en forme des libellés. */
export function dayIndexToDate(day: number): Date {
  return new Date(day * MS_PER_DAY);
}

/** Affichage court d'une date ISO. */
export function fmtDate(iso: string): string {
  return new Date(iso).toLocaleDateString('fr-FR');
}
